module.exports = __webpack_public_path__ + "media/images/vector-30@2x-bf92d40a8107a8d68e88f4dd7570f32a.png";